import { render, staticRenderFns } from "./MemberInviteForm.vue?vue&type=template&id=80fde704&scoped=true"
import script from "./MemberInviteForm.vue?vue&type=script&lang=js"
export * from "./MemberInviteForm.vue?vue&type=script&lang=js"
import style0 from "./MemberInviteForm.vue?vue&type=style&index=0&id=80fde704&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80fde704",
  null
  
)

export default component.exports